module.exports = __webpack_public_path__ + "static/media/red-bb.54b63f30.svg";